import { render, staticRenderFns } from "./userScale.vue?vue&type=template&id=2efdd707&scoped=true"
import script from "./userScale.vue?vue&type=script&lang=js"
export * from "./userScale.vue?vue&type=script&lang=js"
import style0 from "./userScale.vue?vue&type=style&index=0&id=2efdd707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efdd707",
  null
  
)

export default component.exports